import React from 'react'
import {
  AccountPlanDescriptionWrapper,
  AccountsAndPlansAccountName,
  AccountsAndPlansBundle,
  AccountsAndPlansRow,
} from 'Features/accountSettings/routes/AccountSettings/AccountsAndPlans/AccountsAndPlans.styles'
import { AccountPlanDescription } from 'Features/accountSettings/routes/AccountSettings/AccountsAndPlans/AccountPlanDescription'
import { ReactivationAccount } from 'Features/pricing/types/ReactivationAccount'

type AccountPlansRowProps = {
  account: ReactivationAccount
}

export const AccountPlansRow = ({ account }: AccountPlansRowProps) => {
  const subscriptionsProperty = account?.subscriptions[0]
  return (
    <AccountsAndPlansRow>
      <AccountsAndPlansAccountName bundle={!!subscriptionsProperty?.Plan[1]}>
        {account.name}
      </AccountsAndPlansAccountName>
      <AccountPlanDescriptionWrapper>
        <AccountPlanDescription
          productType={subscriptionsProperty?.Plan[0]?.product.product.toLowerCase()}
          planType={subscriptionsProperty?.Plan[0]?.product.planType.toLowerCase()}
          visitsAllowed={subscriptionsProperty?.Plan[0]?.product.visitsAllowed}
        />
        {subscriptionsProperty?.Plan[1] && (
          <AccountsAndPlansBundle>
            <AccountPlanDescription
              productType={subscriptionsProperty?.Plan[1]?.product.product.toLowerCase()}
              planType={subscriptionsProperty?.Plan[1]?.product.planType.toLowerCase()}
              visitsAllowed={subscriptionsProperty?.Plan[1]?.product.visitsAllowed}
            />
          </AccountsAndPlansBundle>
        )}
      </AccountPlanDescriptionWrapper>
    </AccountsAndPlansRow>
  )
}
